import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-basic-popup-ok',
  templateUrl: './basic-popup-ok.component.html',
  styleUrls: ['./basic-popup-ok.component.css']
})

export class BasicPopupOkComponent implements OnInit {

  public messageHeader: string;
  public popupText1: string;
  public popupText2: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<BasicPopupOkComponent>) {

    this.messageHeader = this.data['messageHeader'];
    this.popupText1 = this.data['popupText1'];
    this.popupText2 = this.data['popupText2'];

  }

  ngOnInit(): void {
  }

  ok(){
    this.dialogRef.close(null);
  }

}
